var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path2, _rect21, _rect22, _rect23, _rect24, _rect25, _path3, _rect26, _rect27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 20,
    viewBox: "0 0 148 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 20,
    fill: "#413F5E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 3,
    height: 14,
    fill: "#413F5E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 3,
    height: 17,
    fill: "#413F5E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 3,
    height: 10,
    fill: "#413F5E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 3,
    height: 16,
    fill: "#413F5E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 7,
    width: 3,
    height: 13,
    fill: "#413F5E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 3,
    height: 10,
    fill: "#413F5E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 4,
    width: 3,
    height: 16,
    fill: "#413F5E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 7,
    width: 3,
    height: 13,
    fill: "#413F5E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    width: 3,
    height: 20,
    fill: "#413F5E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 6,
    width: 3,
    height: 14,
    fill: "#413F5E"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 3,
    width: 3,
    height: 17,
    fill: "#413F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 10H63V20H60V10Z",
    fill: "#413F5E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 4,
    width: 3,
    height: 16,
    fill: "#413F5E"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 7,
    width: 3,
    height: 13,
    fill: "#413F5E"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 10,
    width: 3,
    height: 10,
    fill: "#413F5E"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 4,
    width: 3,
    height: 16,
    fill: "#413F5E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 7,
    width: 3,
    height: 13,
    fill: "#413F5E"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 3,
    height: 20,
    fill: "#413F5E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 6,
    width: 3,
    height: 14,
    fill: "#413F5E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 3,
    width: 3,
    height: 17,
    fill: "#413F5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 10H108V20H105V10Z",
    fill: "#413F5E"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 4,
    width: 3,
    height: 16,
    fill: "#413F5E"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 7,
    width: 3,
    height: 13,
    fill: "#413F5E"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    width: 3,
    height: 20,
    fill: "#413F5E"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 6,
    width: 3,
    height: 14,
    fill: "#413F5E"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 3,
    width: 3,
    height: 17,
    fill: "#413F5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135 10H138V20H135V10Z",
    fill: "#413F5E"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 4,
    width: 3,
    height: 16,
    fill: "#413F5E"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 7,
    width: 3,
    height: 13,
    fill: "#413F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioBars);
export default __webpack_public_path__ + "static/media/AudioBars.8cdf7820f17910e1878547e324d853f9.svg";
export { ForwardRef as ReactComponent };